import React from "react";
import Image from "next/image";
//styles
import styles from "./input.module.scss";
//types
import { inputPropsType } from "./types";
import classNames from "classnames";

const Input = ({
  phone,
  leftIcon,
  rightIcon,
  errorText,
  register,
  ...otherprops
}: inputPropsType) => {
  return (
    <div className={classNames(styles.container)}>
      {phone && (
        <div className={styles.row}>
          <div className={classNames(styles["row-center"])}>
            <Image
              src={"/icons/common/india-flag.png"}
              width={26}
              height={26}
              alt="india flag icon"
              className={classNames(styles["mr-6"])}
            />

            <p className={styles.text}>+91</p>
          </div>
          <div className={styles.line} />
        </div>
      )}
      <input
        {...register}
        className={classNames(styles.input_wrapper, styles.text)}
        {...otherprops}
      />
      {errorText && <p className={styles["error-text"]}>{errorText}</p>}
      {rightIcon && rightIcon}
    </div>
  );
};

export default Input;
